<template>
  <div class="product-list-container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'company-admin-campaings-keyword-manager'})"
           class="back-link">
        <svg class="icon"
             width="30px"
             height="30px"
             viewBox="0 0 30 30"
             version="1.1">
          <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                id="path-1">
          </path>
        </svg>
        <p>Back to Keywords</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'company-admin-campaings-keyword-manager'})"
             class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addKeyword">Add Keyword</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-keyword-container">
      <div class="title">Create Keyword</div>
      <div class="col">
        <primary-input class="keyword-name"
                       v-model="keyword"
                       type="text"
                       placeholder="Enter keyword name"
                       name="Keyword" />
        <div class="help is-danger"
             v-if="errorsArray">
          {{errorsArray.keyword[0]}}
        </div>
        <text-area placeholder="Enter description"
                   v-model="keyword_description"
                   maxlength="160"
                   class="text-area-description"
                   name="Description" />
      </div>
      <div class="col text-area">
        <text-area placeholder="Enter script"
                   v-model="keyword_script"
                   maxlength="160"
                   class="text-area-script"
                   name="Script" />
      </div>

    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton"),
    TextArea: () => import("@/components/Inputs/TextArea")
  },
  data: () => ({
    keyword: "",
    keyword_description: "",
    keyword_script: "",
    errorsArray: null
  }),
  methods: {
    addKeyword() {
      this.$store
        .dispatch("PostKeyword", {
          keyword: this.keyword,
          description: this.keyword_description
        })
        .then(() => {
          this.$swal("Created!", "Your keyword has been created.", "success");
          this.$router.push({
            name: "company-admin-campaings-keyword-manager"
          });
        })
        .catch(err => {
          if (err.response.data.errors) {
            this.errorsArray = err.response.data.errors[0];
            setTimeout(() => {
              this.errorsArray = null;
            }, 6000);
          } else {
            this.$snotify.error(err.response.data.error.message, {
              timeout: 4000
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.add-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  margin: 20px 0;
  .back-link {
    cursor: pointer;
    display: flex;
    align-items: center;
    fill: #51a3f3;
    color: #51a3f3;
    font-family: "Helvetica Neue";
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    p {
      margin-bottom: 0;
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
    .primary-button {
      height: 40px;
      width: 130px;
    }
    .secondary-button {
      height: 40px;
      width: 90px;
      margin-right: 20px;
    }
  }
}
.product-list-container {
  padding: 20px;
  .table {
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 90px;
    padding-right: 20px;
    box-sizing: border-box;
    justify-content: space-between;

    .first {
      min-width: fit-content;
      width: calc(20% - 7.5px);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .button-container {
      display: flex;
      justify-content: flex-end;
      flex-direction: row;
      .button {
        margin-top: 20px;
        height: 40px;
        width: 130px;
      }
    }
  }
}
.add-keyword-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  padding: 15px;
  box-sizing: border-box;
  .title {
    height: 30px;
    width: 100%;
    color: #000000;
    font-family: "Helvetica Neue";
    font-size: 18px;
    font-weight: 500;
    line-height: 30px;
    margin-bottom: 15px;
  }
  .col {
    width: calc(50% - 7.5px);
    .text-area-description {
      height: 120px;
    }
    .text-area-script {
      height: 195px;
    }
    .keyword-name {
      margin-bottom: 15px;
    }
  }
  .col.text-area {
    padding-left: 0; 
  }
}
</style>

